module.exports = __webpack_public_path__ + "static/media/ergonomic-2.51cb2297.png";